import { ENDPOINT_PLATFORM, ENDPOINTS } from '../../constants/api'
import { madeRequest } from '../../helpers/api'
import { replaceRouteParams } from '../../helpers/url'

// PLOP_APPEND_PATTERN_ANCHOR

export function getCampaignGraphsService(platform, params) {
  return madeRequest('GET', {
    params,
    url: replaceRouteParams(ENDPOINTS.graphs, {
      platform: ENDPOINT_PLATFORM[platform]
    })
  })
}
